/**
 * Modello dati per ContactInformation
 * Rappresenta una singola informazione di contatto (email, telefono, fax, PEC, ecc.)
 */
export class ContactInformation {

  Oid?: number | null;
  ContactOid?: number | null;
  Type?: number | null;
  Content?: string | null;

  /**
   * Factory method per creare una nuova istanza di ContactInformation
   */
  static create(): ContactInformation {
    return new ContactInformation();
  }

  /**
   * Imposta l'OID del contact a cui appartiene questa informazione
   * @param value OID del contact
   */
  setContactOid(value: number): ContactInformation {
    this.ContactOid = value;
    return this;
  }

  /**
   * Imposta il tipo di informazione (es: email, telefono, fax, PEC)
   * Il tipo è un codice numerico che identifica il tipo di informazione
   * @param value Codice del tipo di informazione
   */
  setType(value: number | null): ContactInformation {
    this.Type = value;
    return this;
  }

  /**
   * Imposta il contenuto dell'informazione (es: indirizzo email, numero di telefono)
   * @param value Contenuto dell'informazione
   */
  setContent(value: string): ContactInformation {
    this.Content = value;
    return this;
  }

}
